import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  AppBar,
  Badge,
  Box,
  Menu,
  MenuItem,
  CircularProgress,
  Hidden,
  IconButton,
  Toolbar,
  Typography
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import InputIcon from '@material-ui/icons/Input';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../store/ducks/auth';
import { setParam } from '../store/ducks/param';
import Logo from './Logo';
import Api from '../utils/api';

const DashboardNavbar = ({ ...rest }) => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const api = new Api();
  const auth = useSelector((state) => state.auth);
  const param = useSelector((state) => state.param);

  const handleClick = (event) => {
    dispatch(setParam({ ...param, sidebarOpenned: !param.sidebarOpenned }));
  };

  useEffect(() => {
    if (!auth || !auth.isLogged || !auth.user || !auth.user.id) {
      if (window.location.href.indexOf('contato') <= -1) {
        window.location.href = '/login';
      }
    }
  }, [auth]);

  return (
    <AppBar elevation={1} {...rest} position="fixed">
      <Toolbar>
        <IconButton edge="start" color="inherit" onClick={handleClick} sx={{ mr: 3 }}>
          <MenuIcon />
        </IconButton>
        <RouterLink to="/">
          <Logo style={{ height: 30, ml: 2 }} />
        </RouterLink>
        <Box sx={{ flexGrow: 1 }} />
        <Hidden>
          <a href="/app/perfil">
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-end',
                color: 'white'
              }}
            >
              <AccountCircleIcon sx={{ mr: 1 }} />
              <Typography variant="h5">{auth.user.name}</Typography>
            </Box>
          </a>
          <IconButton color="inherit" size="large" onClick={() => dispatch(logout())}>
            <InputIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

export default DashboardNavbar;
